import styled from "styled-components";

export const StyledButton = styled.button`
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    background: ${(props) => (props.isActive ? "rgba(0, 0, 0, 0.08)" : "white")};
    border: none;

    img {
        width: 20px;
    }
`;